export default __webpack_public_path__ + "static/PeopleEmotions_mobile-547960418ffb7e4edad216416b243734.png";